import { useTranslation } from 'react-i18next';
import { useTerminateWorker, useHandleJobApplication } from 'src/api/hooks/useJob';
import { useRemoveWorkerRequest, useResendInviteRequest } from 'src/api/hooks/useWorker';
import { useStoreActions } from 'src/stores';
import { PopUpEnum } from 'src/stores/NotificationStore';

export const useWorkerActions = () => {
  const { t } = useTranslation();
  const setPopUpData = useStoreActions(action => action.popUp.setPopUp);

  const [resendWorkerInvite, { loading: resendWorkerInviteLoading }] = useResendInviteRequest({
    onComplete: () => {
      setPopUpData({
        isOpen: true,
        type: PopUpEnum.success,
        message: t('workersPage.actions.resendInvite.success'),
      });

      window.location.reload();
    },
    onError: () =>
      setPopUpData({
        isOpen: true,
        type: PopUpEnum.error,
        message: t('workersPage.actions.resendInvite.error'),
      }),
  });

  const [removeWorkerFromCompany, { loading: removeWorkerFromCompanyLoading }] =
    useRemoveWorkerRequest({
      onComplete: () => {
        setPopUpData({
          isOpen: true,
          type: PopUpEnum.success,
          message: t('workersPage.actions.removeWorkerFromCompany.success'),
        });

        window.location.reload();
      },
      onError: () =>
        setPopUpData({
          isOpen: true,
          type: PopUpEnum.error,
          message: t('workersPage.actions.removeWorkerFromCompany.error'),
        }),
    });

  const [terminateWorker, { loading: terminateWorkersLoading }] = useTerminateWorker({
    onComplete: () => {
      setPopUpData({
        isOpen: true,
        type: PopUpEnum.success,
        message: t('workersPage.actions.terminateWorker.success'),
      });

      window.location.reload();
    },
    onError: () =>
      setPopUpData({
        isOpen: true,
        type: PopUpEnum.error,
        message: t('workersPage.actions.terminateWorker.error'),
      }),
  });

  const [handleJobApplication, { loading: handleApplicationLoading }] = useHandleJobApplication({
    onComplete: () => {
      setPopUpData({
        isOpen: true,
        type: PopUpEnum.success,
        message: t('workersPage.actions.handleApplication.success'),
      });

      window.location.reload();
    },
    onError: () =>
      setPopUpData({
        isOpen: true,
        type: PopUpEnum.error,
        message: t('workersPage.actions.handleApplication.error'),
      }),
  });

  const isLoading =
    terminateWorkersLoading ||
    removeWorkerFromCompanyLoading ||
    resendWorkerInviteLoading ||
    handleApplicationLoading;

  return {
    isLoading,
    resendWorkerInvite,
    handleJobApplication,
    terminateWorker,
    removeWorkerFromCompany,
  };
};
